import { Component } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import { BaseTopAppBarComponent } from '../base-top-app-bar/base-top-app-bar.component';

/**
 * Landing page top app bar that extends the base toolbar.
 * Shows just the PermitProof logo and user profile menu - clean and minimal.
 * Used for the home page and other non-project, non-admin pages.
 *
 * Based on Angular component inheritance guide:
 * https://angular.dev/guide/components/inheritance
 */
@Component({
  selector: 'app-landing-top-app-bar',
  imports: [MatButtonModule, MatIconModule, MatMenuModule, MatDividerModule, BaseTopAppBarComponent],
  templateUrl: './landing-top-app-bar.component.html',
  styleUrls: ['./landing-top-app-bar.component.scss'],
})
export class LandingTopAppBarComponent extends BaseTopAppBarComponent {
  onSwitchAccount(): void {
    this.switchAccount.emit();
  }
}
